import type { FaireProductEntity } from "../../entity_types/product";

export const p_85yqhg7ah3: FaireProductEntity = {
  token: "p_85yqhg7ah3",
  type: "product",
  name: "Lavender Fig - Medium Glass - Just Bee Candle",
  brandToken: "b_16wdwaco",
  brandName: "Just Bee",
  imageUrl:
    "https://cdn.faire.com/fastly/e3d0cd6b9fc76aa82146ed133fcee695e85b8cf1e4635dc5fe4cc8a563c9228e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/08571a14a77d6f92835514eb9a528f0ad83ebb0082451ab5016eb397b117aa6b.jpeg",
  ],
  priceDollars: 11.99,
  description:
    "Imagine a serene escape into a lush, sun-kissed garden where the soothing aroma of lavender gently intertwines with the unique, sweet freshness of figs.\n\n• Embrace the tranquility blending of calming essence of lavender.\n• Succulent notes of fresh fig.\n• The heart of this scent lies in its earthy undertones, where the rich warmth of cedarwood meets the crisp, green embrace of fern, evoking a sense of peaceful, rustic elegance.\n\nThis candle is perfect for creating a tranquil ambiance in your home or as a thoughtful gift for someone special. With its alluring aroma and beautifully crafted design, the Lavender Fig candle transforms any space into a haven of relaxation.\n\nMedium Glass | Up to 40 Hrs of Clean Burning",
  tags: [],
  msrpDollars: 23.98,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:47:57.917Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
